export default {
  title: "Търсене",
  subtitle: "Търсене на пациенти, проби и резултати",
  comingSoon: "Очаквайте скоро",
  description: "Тази функция ще предостави цялостно търсене на пациенти, проби и резултати.",
};
